import { render, staticRenderFns } from "./backtop.vue?vue&type=template&id=b5d42130"
import script from "./backtop.vue?vue&type=script&lang=ts"
export * from "./backtop.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports